import React, { useEffect, useState } from 'react';
import Link from '@visa/vds/link'
import Textfield from '@cybs-ui/components/lib/textfield';
import { useSelector } from 'react-redux';
import showDivBasedOnId, { hideDivBasedOnId } from '../../../commons/ui-commons';
import { getCredCookie } from '../../../libs/common-library';
import { getCurrentHTTPMerchantId, getCurrentKeyId, getIsWidget,getPartnerName } from '../../../lhs/reducers/configuration-reducer';

const handleFocus = (setDefault, setTextStyle) => {
    setDefault('');
    setTextStyle({border: "1px solid #b6b6b9", color: 'black'});
}

const resetTextField = (defaultString, setDefault, setTextStyle) => {
    setDefault(defaultString);
    setTextStyle({border: "1px solid #b6b6b9", color: 'grey'});
}

const HTTPSignatureSet = (props) => {
    var partnerName = getPartnerName();
    const processor = useSelector(state => state.configurationReducer.processor);
    const [merchantID_def, setMerchantIDDefault] = useState('Organization ID');
    const [key_def, setKeyDefault] = useState('Key');
    const [secretKey_def, setSecretKeyDefault] = useState('Secret Key');
    const [merchantID_textstyle, setMerchantIDTextStyle] = useState({border: "1px solid #b6b6b9", color: "grey"});
    const [key_textstyle, setKeyTextStyle] = useState({border: "1px solid #b6b6b9", color: "grey"});
    const [secretKey_textstyle, setSecretKeyTextStyle] = useState({border: "1px solid #b6b6b9", color: "grey"});
    const activeTextField = {border: "1px solid #b6b6b9", color: 'black'};
    useEffect(function switchState(){
        hideDivBasedOnId('updated-creds-http-api');
        hideDivBasedOnId('updated-creds-http-endpoint');
        showDivBasedOnId('default-creds-http-api');
        showDivBasedOnId('default-creds-http-endpoint');
    },[props.reset])

    useEffect(function switchState(){
        if(getCredCookie('merchantId')==='testrest'){
            resetTextField('Key', setKeyDefault, setKeyTextStyle);
            resetTextField('Secret Key', setSecretKeyDefault, setSecretKeyTextStyle);
        }
    },[props.update])
    var hash = window.location.hash;
    var currentSecretKey = useSelector(state => state.configurationReducer.currentSecretKey);
    useEffect(function switchState(){
        if(currentSecretKey){
            props.setSecretKey(currentSecretKey);
            props.setMerchantId(getCurrentHTTPMerchantId());
            props.setKeyID(getCurrentKeyId());
        }
        else{
            props.setSecretKey('');
            props.setMerchantId('');
            props.setKeyID('');
            if(!(merchantID_def===' '||merchantID_def==='Organization ID')){
                resetTextField('Organization ID', setMerchantIDDefault, setMerchantIDTextStyle);
            }
            if(!(key_def===' '||key_def==='Key')){
                resetTextField('Key', setKeyDefault, setKeyTextStyle);
            }
            if(!(secretKey_def===' '||secretKey_def==='Secret Key')){
                resetTextField('Secret Key', setSecretKeyDefault, setSecretKeyTextStyle);
            }
        }
    },[currentSecretKey]);
    return (
     <div>
      <div class= "sandBoxDetailsCard">Sandbox Credentials</div>   
      <p id={"default-creds-http-"+props.src.toLowerCase()} style={{display:'block'}}>You are using default sandbox account of {processor} processor. Enter new credentials here to change the account. Don't have keys?&nbsp;
      <Link class="color_theme_link" href = {`/docs/${partnerName}/en-us/platform/developer/all/rest/rest-getting-started/restgs-http-message-intro.html`} target="_blank" rel="noopener">Read our guide </Link>to learn more about the keys. Required fields are denoted with an <mark class = "red">*</mark>.</p>
      <p id={"updated-creds-http-"+props.src.toLowerCase()} style={{display:'none'}}>You are using your own sandbox account. Use the Reset button to revert to default credentials.</p>      
      <div class = "httpsignatureDiv">
        <div class = "httpSignatureItems">
            <div style={{margin:'5px'}}>
                <Textfield
                    className="text-field-mock"
                    i18n={{ label: 'Organization ID' }}
                    required={true}
                    width='300px'
                    value={(props.merchantId !== '')?props.merchantId:merchantID_def}
                    onFocus={() => handleFocus(setMerchantIDDefault, setMerchantIDTextStyle)}
                    onBlur={e => (e.target.value === '') ? resetTextField('Organization ID', setMerchantIDDefault, setMerchantIDTextStyle) : 1}
                    onChange={e => props.setMerchantId(e.target.value)}
                    style={(props.merchantId !== '')?activeTextField:merchantID_textstyle}
                />
            </div>
            <div style={{margin:'5px'}}>
                <Textfield
                    i18n={{ label: 'Key' }}
                    required={true}
                    width='300px'
                    value={(props.keyID !== '')?props.keyID:key_def}
                    onFocus={() => handleFocus(setKeyDefault, setKeyTextStyle)}
                    onBlur={e => (e.target.value === '') ? resetTextField('Key', setKeyDefault, setKeyTextStyle) : 1}
                    onChange={e => props.setKeyID(e.target.value)}
                    style={(props.keyID !== '')?activeTextField:key_textstyle}
                />
            </div>
            <div style={{margin:'5px'}}>
                <Textfield
                    i18n={{ label: 'Shared Secret Key' }}
                    required={true}
                    width='300px'
                    value={(props.secretKey !== '')?props.secretKey:secretKey_def}
                    onFocus={() => handleFocus(setSecretKeyDefault, setSecretKeyTextStyle)}
                    onBlur={e => (e.target.value === '') ? resetTextField('Secret Key', setSecretKeyDefault, setSecretKeyTextStyle) : 1}
                    onChange={e => props.setSecretKey(e.target.value)}
                    style={(props.secretKey !== '' )?activeTextField:secretKey_textstyle}
                />
            </div>
        </div>
     </div>
    </div>
    )
}

HTTPSignatureSet.displayName = 'HTTPSignatureSet';
export default HTTPSignatureSet;
